import { writable } from "svelte/store";
import type { Writable } from 'svelte/store';

export const catalogMode = writable(false);

export type OverlayId = | 'login' | 'stampEditor' | 'setEditor' | 'stampInSetEditor' | 'blockEditor' | 'bookletEditor' | 'seTenantsEditor' | 'import' | 'stampViewer' | 'itemSearch' | 'suggestionSearch' | 'userDashboard' | 'registerUser' | 'manual' | 'help';

type OverlayState = Record<OverlayId, boolean>;

const initial: OverlayState = {
    login: false,
    stampEditor: false,
    setEditor: false,
    stampInSetEditor: false,
    blockEditor: false,
    bookletEditor: false,
    seTenantsEditor: false,
    import: false,
    stampViewer: false,
    itemSearch: false,
    suggestionSearch: false,
    userDashboard: false,
    registerUser: false,
    manual: false,
    help: false,
};

const _helpSectionId = writable('');
export const helpSectionId: Writable<string> = _helpSectionId;

const overlays = writable<OverlayState>(initial);

/*
Get a writable store for a single overlay, suitable for bind:open
Usage in a component:
    const bIsLoginOpen = overlay('login')
    <Dialog bind:open={$bIsLoginOpen}/>
*/
export function overlay(id: OverlayId): Writable<boolean> {
    return {
        // derived read
        subscribe: (run: (v: boolean) => void) =>
            overlays.subscribe((s: OverlayState) => run(s[id])),
        set: (value: boolean) => 
            overlays.update((s: OverlayState) => ({ ...s, [id]: value })),
        update: (fn: (v: boolean) => boolean) =>
            overlays.update((s: OverlayState) => ({ ...s, [id]: fn(s[id]) }))
    };
}

export const ui = {
    subscribe: overlays.subscribe,
    open:   (id: OverlayId) => overlays.update((s: OverlayState) => ({ ...s, [id]: true})),
    close:  (id: OverlayId) => overlays.update((s: OverlayState) => ({ ...s, [id]: false})),
    toggle: (id: OverlayId) => overlays.update((s: OverlayState) => ({ ...s, [id]: !s[id]})),
    closeAll: (() => overlays.update((s) => Object.fromEntries(Object.keys(s).map((k) => [k, false])) as OverlayState))
};

export function openHelp(sectionId: string): void {
    _helpSectionId.set(sectionId);
    overlays.update((s: OverlayState) => ({ ...s, help: true }));
}